import HeaderMain from "../comp/head-navs-main";
import ViewContent from "../comp/view-content";
import ViewDividerSmall from "../comp/view-divider-sm";
import ViewDividerMedium from "../comp/view-divider-md";
import ViewSectionName from "../comp/view-section-name";

import TeacherRoomListModule from "../comp/bsnx-room-list";

export default function RoomsBz() {


  return (
    <>
      <HeaderMain />
      <ViewContent 
        content={
          <>
            <ViewDividerSmall />
            <TeacherRoomListModule />

          </>
        }
      />
      

    </>
  )
}